/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_OverdueInputs */

const en_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`overdue`)
};

const id_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jatuh tempo`)
};

const ms_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tertunggak`)
};

const ca_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vençut`)
};

const cs_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`po splatnosti`)
};

const da_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`forfalden`)
};

const de_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überfällig`)
};

const et_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aegunud`)
};

const es_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vencido`)
};

const fr_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`non payé`)
};

const hr_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kasni`)
};

const it_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DA PAGARE`)
};

const lv_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kavēts`)
};

const lt_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pradelsta`)
};

const hu_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`késedelmes`)
};

const nl_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`achterstallig`)
};

const nb_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`forfalt`)
};

const pl_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zaległa`)
};

const pt_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vencido`)
};

const ro_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`scadent`)
};

const sk_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`omeškanie`)
};

const sl_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zamujeno`)
};

const fi_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`erääntynyt`)
};

const sv_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`försenad`)
};

const vi_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`quá hạn`)
};

const tr_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gecikmiş`)
};

const el_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`εκπρόθεσμο`)
};

const bg_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`просрочени`)
};

const ru_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`просрочено`)
};

const sr_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`касни`)
};

const uk_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`прострочено`)
};

const ka_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ვადაგადაცილებული`)
};

const hi_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओवरड्यू `)
};

const th_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้างชำระ`)
};

const ko_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연체`)
};

const zh_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`逾期`)
};

const zh_tw_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`逾期`)
};

const ja_status_overdue = /** @type {(inputs: Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未払い`)
};

/**
* | output |
* | --- |
* | "overdue" |
*
* @param {Status_OverdueInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const status_overdue = /** @type {((inputs?: Status_OverdueInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_OverdueInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_status_overdue(inputs)
	if (locale === "ms") return ms_status_overdue(inputs)
	if (locale === "ca") return ca_status_overdue(inputs)
	if (locale === "cs") return cs_status_overdue(inputs)
	if (locale === "da") return da_status_overdue(inputs)
	if (locale === "de") return de_status_overdue(inputs)
	if (locale === "et") return et_status_overdue(inputs)
	if (locale === "es") return es_status_overdue(inputs)
	if (locale === "fr") return fr_status_overdue(inputs)
	if (locale === "hr") return hr_status_overdue(inputs)
	if (locale === "it") return it_status_overdue(inputs)
	if (locale === "lv") return lv_status_overdue(inputs)
	if (locale === "lt") return lt_status_overdue(inputs)
	if (locale === "hu") return hu_status_overdue(inputs)
	if (locale === "nl") return nl_status_overdue(inputs)
	if (locale === "nb") return nb_status_overdue(inputs)
	if (locale === "pl") return pl_status_overdue(inputs)
	if (locale === "pt") return pt_status_overdue(inputs)
	if (locale === "ro") return ro_status_overdue(inputs)
	if (locale === "sk") return sk_status_overdue(inputs)
	if (locale === "sl") return sl_status_overdue(inputs)
	if (locale === "fi") return fi_status_overdue(inputs)
	if (locale === "sv") return sv_status_overdue(inputs)
	if (locale === "vi") return vi_status_overdue(inputs)
	if (locale === "tr") return tr_status_overdue(inputs)
	if (locale === "el") return el_status_overdue(inputs)
	if (locale === "bg") return bg_status_overdue(inputs)
	if (locale === "ru") return ru_status_overdue(inputs)
	if (locale === "sr") return sr_status_overdue(inputs)
	if (locale === "uk") return uk_status_overdue(inputs)
	if (locale === "ka") return ka_status_overdue(inputs)
	if (locale === "hi") return hi_status_overdue(inputs)
	if (locale === "th") return th_status_overdue(inputs)
	if (locale === "ko") return ko_status_overdue(inputs)
	if (locale === "zh") return zh_status_overdue(inputs)
	if (locale === "zh-tw") return zh_tw_status_overdue(inputs)
	if (locale === "ja") return ja_status_overdue(inputs)
	return en_status_overdue(inputs)
});